/**
 * AllAll 图片 Flux 系列通用参数：prompt、aspect_ratio 必填，n/size/response_format 可选
 * 各模型参数一致，仅 model 字段不同，由各 adapter 传入
 */
var ASPECT_RATIOS = ['21:9', '16:9', '4:3', '3:2', '1:1', '2:3', '3:4', '9:16', '9:21']

function normalizeAspectRatio(v) {
  if (!v || typeof v !== 'string') return '1:1'
  var s = v.replace(/：/g, ':').trim()
  return ASPECT_RATIOS.indexOf(s) !== -1 ? s : '1:1'
}

/**
 * 构建 POST /v1/images/generations 的 JSON Body（用于 Flux 系列）
 * 不传 size，接口仅用 aspect_ratio 控制比例。
 * @param {string} model - 如 'flux-kontext-pro'
 * @param {Object} params - prompt(必填), aspectRatio/aspect_ratio, n, response_format
 */
export function buildBodyWithModel(model, params) {
  var prompt = (params.prompt || '').trim().slice(0, 1000)
  if (!prompt) throw new Error('prompt 必填')
  var allowedStyles = ['auto', 'photographic', 'digital_art', 'anime']
  var style = String(params.style || 'auto')
  if (allowedStyles.indexOf(style) === -1) style = 'auto'
  var body = {
    model: model,
    prompt: prompt,
    aspect_ratio: normalizeAspectRatio(params.aspect_ratio || params.aspectRatio),
    n: Math.min(10, Math.max(1, parseInt(params.n || params.count || 1, 10) || 1)),
    style: style
  }
  if (params.response_format === 'b64_json' || params.responseFormat === 'b64_json') {
    body.response_format = 'b64_json'
  } else {
    body.response_format = 'url'
  }
  if (params.user != null && String(params.user).trim()) {
    body.user = String(params.user).trim()
  }
  return body
}

